import { CheckForm, CheckQuiz, validators } from "@/components/site/CheckTools";
import { openCallReason } from "@/lib/site";

const FIELDS = [
  { key: "property_type", type: "select", placeholder: "Tipo di struttura", options: ["Casa vacanze", "B&B", "Affittacamere", "Sto per aprire"], validate: validators.required("Scegli il tipo di struttura.") },
  { key: "city", type: "text", placeholder: "Città", validate: validators.minLen(2, "Scrivi la città della struttura.") },
  { key: "whatsapp", type: "tel", placeholder: "Numero WhatsApp, es. +39 347 1234567", validate: validators.phone },
];

export function ComplianceCheckForm() {
  return (
    <CheckForm
      id="check-regola"
      testid="compliance-check-form"
      kicker="Check gratuito: sei in regola?"
      fields={FIELDS}
      endpoint="/api/compliance-checks"
      buttonLabel="Fai il check con Valerio"
      consentText="e acconsento a essere ricontattato su WhatsApp per questo check."
      promise={
        <>
          Entro 48 ore ti scriviamo su <span className="font-medium text-[#FAF7F2]">WhatsApp</span> e fissiamo 30 minuti con Valerio: 5 domande, una risposta chiara.
        </>
      }
      secondaryLink={{ to: "/aprire-struttura-ricettiva-sicilia", label: "Stai per aprire? Parti da qui" }}
    />
  );
}

const DOMANDE = [
  "Il CIN è esposto in tutti i tuoi annunci?",
  "Hai depositato la SCIA in comune?",
  "Versi regolarmente l'imposta di soggiorno?",
  "Sai se il tuo regime fiscale è il più adatto al tuo caso?",
  "Gli incassi dei portali sono registrati e riconciliati?",
];

export function ComplianceQuiz() {
  return (
    <CheckQuiz
      testid="compliance-quiz"
      kicker="Gratis, per cominciare"
      title="Sei in regola? 5 domande, 1 minuto."
      questions={DOMANDE}
      resultOk="Sembri in ordine. Vuoi una conferma? 30 minuti gratis con Valerio."
      resultKo={(n) => (
        <>
          Ci sono <span className="text-[#E05A2C]">{n}</span> {n === 1 ? "punto" : "punti"} da verificare. Manda le risposte a Valerio: ti dice cosa sistemare e in che ordine.
        </>
      )}
      waLabel="Manda le risposte a Valerio"
      waMessage={(righe, stato) => `Ciao, ho fatto il test sulla pagina del commercialista. La mia struttura è ${stato}. Ecco le mie risposte: ${righe}. Vorrei parlarne con Valerio.`}
      extraOk={{ label: "Prenota i 30 minuti", onClick: () => openCallReason("commercialista-in-regola") }}
    />
  );
}
